<template>
  <Popover v-if="user" class="relative bg-black border-gray-900">
    <div class="max-w-7xl mx-auto px-4 sm:px-6">
      <div class="flex items-end py-6 justify-between md:space-x-10">
        <div class="flex justify-start lg:w-0 lg:flex-1">
          <button @click="toHome">
            <img class="h-8 w-auto sm:h-10" src="../assets/logo.svg" alt="" />
          </button>
        </div>
        <button
          @click="toHome"
          href="#"
          class="
            text-base
            font-semibold
            text-gray-200
            hover:text-gray-400
            hidden
            md:flex
          "
        >
          Events
        </button>
        <div class="-mr-2 -my-2 md:hidden">
          <PopoverButton
            class="
              bg-gray-900
              rounded-md
              p-2
              inline-flex
              items-center
              justify-center
              text-gray-200
              hover:bg-gray-800
              focus:outline-none
              focus:ring-2
              focus:ring-inset
              focus:ring-gray-800
            "
          >
            <span class="sr-only">Open menu</span>
            <MenuIcon class="h-6 w-6" aria-hidden="true" />
          </PopoverButton>
        </div>
        <PopoverGroup as="nav" class="hidden md:flex space-x-10">
          <Popover
            class="relative"
            v-slot="{ open }"
            v-if="user.role == 'admin'"
          >
            <PopoverButton
              :class="[
                open ? 'text-gray-900' : 'text-gray-200',
                'group  bg-transparent rounded-md inline-flex items-center text-base font-semibold hover:text-gray-400 focus:outline-none focus:ring-none focus:ring-offset-2 focus:ring-red-700',
              ]"
            >
              <span>Manage</span>
              <ChevronDownIcon
                :class="[
                  open ? 'text-gray-600' : 'text-gray-400',
                  'ml-2 h-5 w-5 group-hover:text-gray-500',
                ]"
                aria-hidden="true"
              />
            </PopoverButton>

            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="opacity-0 translate-y-1"
              enter-to-class="opacity-100 translate-y-0"
              leave-active-class="transition ease-in duration-150"
              leave-from-class="opacity-100 translate-y-0"
              leave-to-class="opacity-0 translate-y-1"
            >
              <PopoverPanel
                class="
                  absolute
                  backdrop-blur-md
                  z-10
                  -ml-4
                  mt-3
                  transform
                  px-2
                  w-screen
                  max-w-md
                  sm:px-0
                  lg:ml-0 lg:left-1/2 lg:-translate-x-1/2
                "
              >
                <div
                  class="
                    rounded-lg
                    shadow-lg
                    ring-1 ring-black ring-opacity-5
                    overflow-hidden
                  "
                >
                  <div
                    class="
                      relative
                      grid
                      gap-6
                      bg-gray-900
                      opacity-90
                      px-5
                      py-6
                      sm:gap-8 sm:p-8
                    "
                  >
                    <PopoverButton
                      v-for="item in links"
                      :key="item.name"
                      @click="navigate(item.to)"
                      class="
                        -m-3
                        p-3
                        flex
                        items-start
                        rounded-lg
                        hover:bg-gray-800
                      "
                    >
                      <component
                        :is="item.icon"
                        class="flex-shrink-0 h-6 w-6 text-gray-200"
                        aria-hidden="true"
                      />
                      <div class="flex flex-col ml-4">
                        <p
                          class="text-base font-medium text-gray-200 text-left"
                        >
                          {{ item.name }}
                        </p>
                        <p class="mt-1 text-sm text-gray-500">
                          {{ item.description }}
                        </p>
                      </div>
                    </PopoverButton>
                  </div>
                </div>
              </PopoverPanel>
            </transition>
          </Popover>
        </PopoverGroup>
        <PopoverGroup
          as="nav"
          class="hidden md:flex items-center justify-end md:flex-1 lg:w-0"
        >
          <Popover class="relative" v-slot="{ open }">
            <PopoverButton
              :class="[
                open ? 'text-gray-400' : 'text-gray-200',
                'group bg-transparent rounded-md inline-flex items-center text-base font-semibold hover:text-gray-400 focus:outline-none focus:ring-none focus:ring-offset-2 focus:ring-red-700',
              ]"
            >
              <span>{{ user.firstName }} {{ user.lastName }}</span>
              <UserCircleIcon
                :class="[
                  open ? 'text-gray-400' : 'text-gray-200',
                  'ml-2 h-5 w-5 group-hover:text-gray-500',
                ]"
                aria-hidden="true"
              />
            </PopoverButton>

            <transition
              enter-active-class="transition ease-out duration-200"
              enter-from-class="opacity-0 translate-y-1"
              enter-to-class="opacity-100 translate-y-0"
              leave-active-class="transition ease-in duration-150"
              leave-from-class="opacity-100 translate-y-0"
              leave-to-class="opacity-0 translate-y-1"
            >
              <PopoverPanel
                class="
                  absolute
                  backdrop-blur-md
                  z-10
                  mt-3
                  transform
                  px-2
                  w-screen
                  max-w-xs
                  sm:px-0
                  ml-0
                  left-full
                  -translate-x-full
                "
              >
                <div
                  class="
                    rounded-lg
                    shadow-lg
                    ring-1 ring-black ring-opacity-5
                    overflow-hidden
                  "
                >
                  <div
                    class="
                      relative
                      grid
                      gap-6
                      bg-gray-900
                      opacity-90
                      px-5
                      sm:gap-8 sm:p-8
                    "
                  >
                    <div
                      class="
                        -mt-7
                        -m-3
                        p-3
                        flex flex-col
                        items-start
                        border-b-2 border-gray-800
                      "
                    >
                      <h1 class="text-base font-medium text-gray-200 text-left">
                        {{ user.firstName }} {{ user.lastName }}
                      </h1>
                      <h2
                        class="
                          text-sm
                          font-medium
                          text-gray-400 text-left
                          capitalize
                        "
                      >
                        {{ user.role }}
                      </h2>
                    </div>
                    <PopoverButton
                      @click="changePassword"
                      class="
                        -m-3
                        p-3
                        flex
                        items-start
                        rounded-lg
                        hover:bg-gray-800
                      "
                    >
                      <ShieldCheckIcon
                        class="flex-shrink-0 h-6 w-6 text-gray-200"
                        aria-hidden="true"
                      />
                      <div class="flex flex-col ml-4">
                        <p class="text-sm font-medium text-gray-200 text-left">
                          Change Password
                        </p>
                      </div>
                    </PopoverButton>
                    <PopoverButton
                      @click="handleSignOut"
                      class="
                        -m-3
                        p-3
                        flex
                        items-start
                        rounded-lg
                        hover:bg-gray-800
                      "
                    >
                      <LogoutIcon
                        class="flex-shrink-0 h-6 w-6 text-gray-200"
                        aria-hidden="true"
                      />
                      <div class="flex flex-col ml-4">
                        <p class="text-sm font-medium text-gray-200 text-left">
                          Sign Out
                        </p>
                      </div>
                    </PopoverButton>
                  </div>
                </div>
              </PopoverPanel>
            </transition>
          </Popover>
        </PopoverGroup>
      </div>
    </div>

    <transition
      enter-active-class="duration-200 ease-out"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="duration-100 ease-in"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <PopoverPanel
        focus
        class="
          absolute
          top-0
          inset-x-0
          p-2
          transition
          transform
          origin-top-right
          backdrop-blur-sm
          md:hidden
          z-50
        "
      >
        <div
          class="
            rounded-lg
            shadow-lg
            ring-1 ring-black ring-opacity-5
            bg-gray-900
            opacity-90
            divide-y-2 divide-gray-800
          "
        >
          <div class="pt-5 pb-6 px-5">
            <div class="flex items-center justify-between">
              <div>
                <img
                  class="h-8 w-auto"
                  src="../assets/logo.svg"
                  alt="Workflow"
                />
              </div>
              <div class="-mr-2">
                <PopoverButton
                  class="
                    bg-gray-900
                    rounded-md
                    p-2
                    inline-flex
                    items-center
                    justify-center
                    text-gray-200
                    hover:bg-gray-800
                    focus:outline-none
                    focus:ring-2
                    focus:ring-inset
                    focus:ring-gray-800
                  "
                >
                  <span class="sr-only">Close menu</span>
                  <XIcon class="h-6 w-6" aria-hidden="true" />
                </PopoverButton>
              </div>
            </div>
            <div class="mt-6 space-y-5">
              <nav class="grid gap-y-8">
                <PopoverButton
                  @click="toHome"
                  class="
                    -m-3
                    p-3
                    flex
                    items-center
                    rounded-md
                    hover:bg-gray-800
                  "
                >
                  <CalendarIcon
                    class="flex-shrink-0 h-6 w-6 text-gray-200"
                    aria-hidden="true"
                  />
                  <span class="ml-3 text-base font-medium text-gray-200">
                    Events
                  </span>
                </PopoverButton>
                <PopoverButton
                  @click="navigate('/admin/user/list')"
                  v-if="user.role == 'admin'"
                  class="
                    -m-3
                    p-3
                    flex
                    items-center
                    rounded-md
                    hover:bg-gray-800
                  "
                >
                  <UsersIcon
                    class="flex-shrink-0 h-6 w-6 text-gray-200"
                    aria-hidden="true"
                  />
                  <span class="ml-3 text-base font-medium text-gray-200">
                    Users
                  </span>
                </PopoverButton>
              </nav>
            </div>
          </div>
          <div class="py-6 px-5 space-y-6">
            <div class="flex flex-col">
              <h1 class="text-base font-medium text-gray-200 text-left">
                {{ user.firstName }} {{ user.lastName }}
              </h1>
              <h2
                class="text-sm font-medium text-gray-400 text-left capitalize"
              >
                {{ user.role }}
              </h2>
            </div>
            <div class="mt-6 space-y-5">
              <nav class="grid gap-y-8">
                <PopoverButton
                  @click="changePassword"
                  class="
                    -m-3
                    p-3
                    flex
                    items-center
                    rounded-md
                    hover:bg-gray-800
                  "
                >
                  <ShieldCheckIcon
                    class="flex-shrink-0 h-6 w-6 text-gray-200"
                    aria-hidden="true"
                  />
                  <span class="ml-3 text-base font-medium text-gray-200">
                    Change password
                  </span>
                </PopoverButton>
                <PopoverButton
                  @click="handleSignOut"
                  class="
                    -m-3
                    p-3
                    flex
                    items-center
                    rounded-md
                    hover:bg-gray-800
                  "
                >
                  <LogoutIcon
                    class="flex-shrink-0 h-6 w-6 text-gray-200"
                    aria-hidden="true"
                  />
                  <span class="ml-3 text-base font-medium text-gray-200">
                    Sign out
                  </span>
                </PopoverButton>
              </nav>
            </div>
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>

  <PasswordReset />
</template>

<script setup>
import {
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/vue";
import {
  MenuIcon,
  CalendarIcon,
  UsersIcon,
  XIcon,
  ShieldCheckIcon,
  LogoutIcon,
  UserCircleIcon,
} from "@heroicons/vue/outline";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import { useStore } from "vuex";
import { computed } from "vue";
import { useRouter } from "vue-router";
import emitter from "../utils/emitter.js";
import PasswordReset from "./User/UserUpdatePassword.vue";

const store = useStore();
const router = useRouter();

//Navigate to home
const toHome = () => {
  if (user.value.role === "admin") {
    router.push("/admin");
  } else {
    router.push("/event/list");
  }
};

//Navigate to home
const navigate = (to) => {
  router.push(to);
};
//Sign out function
const handleSignOut = async () => {
  await store
    .dispatch("signOut")
    .then(() => {
      router.push("/login");
    })
    .catch((err) => {
      alert("Error: " + err);
    });
};

//** Change password */

const changePassword = () => {
  //Emit notification
  emitter.emit("showPasswordChange", {
    show: true,
  });
};

//Get current user from store
const user = computed(() => store.getters.getUser);

//Data
const links = [
  {
    name: "Users",
    description: "Manage all application users",
    to: "/admin/user/list",
    icon: UsersIcon,
  },
];
</script>